export default function goToAnchor(refs, anchorTo) {
  if (refs && anchorTo) {
    refs.current[anchorTo].current.scrollIntoView({ block: 'end' });
  }
}
